import { render, staticRenderFns } from "./HelpWidget.vue?vue&type=template&id=10bb68e8&scoped=true"
import script from "./HelpWidget.vue?vue&type=script&lang=js"
export * from "./HelpWidget.vue?vue&type=script&lang=js"
import style0 from "./HelpWidget.vue?vue&type=style&index=0&id=10bb68e8&prod&scoped=true&lang=css"
import style1 from "./HelpWidget.vue?vue&type=style&index=1&id=10bb68e8&prod&scoped=true&lang=css"
import style2 from "./HelpWidget.vue?vue&type=style&index=2&id=10bb68e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb68e8",
  null
  
)

export default component.exports